import {
  PropsWithChildren,
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
  useReducer,
  useMemo,
} from "react";
import { ContentCategory } from "types/appConfigV2";
import { SearchActionTypes, searchReducer, SearchState } from "./search";

type IProps = PropsWithChildren<{
  initialCategory: ContentCategory;
}>;

export type ContentView = "grid" | "list";

const FilterContext = createContext<{
  contentView: ContentView;
  setContentView: Dispatch<SetStateAction<ContentView>>;
  searchState: SearchState;
  searchDispatch: Dispatch<SearchActionTypes>;
}>(undefined!);

export const FilterProvider = ({ initialCategory, children }: IProps) => {
  const [contentView, setContentView] = useState<ContentView>("grid");
  let initialSearchModel = initialCategory.filter || {};
  initialSearchModel = Object.assign(
    initialSearchModel,
    { deploymentSiteIds: [initialCategory.deploymentSiteId] },
    initialCategory.rootFolderId
      ? { folderIds: [initialCategory.rootFolderId] }
      : null
  );

  // @ts-ignore
  const [searchState, searchDispatch] = useReducer(searchReducer, {
    search: initialSearchModel,
    defaultDeploymentSiteId: initialCategory.deploymentSiteId,
    currentDeploymentSiteId: initialCategory.deploymentSiteId,
    imageTemplateId: initialCategory.imageTemplateId,
    currentCategory: initialCategory,
    currentFolderId: initialCategory.rootFolderId,
    activeFilters: [],
  });

  const searchMemo = useMemo(() => {
    return { searchState, searchDispatch };
  }, [searchState, searchDispatch]);

  return (
    <FilterContext.Provider
      value={{
        contentView,
        setContentView,
        searchState: searchMemo.searchState,
        searchDispatch: searchMemo.searchDispatch,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  let context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};
